/* OVD feature bundle — consolidated from per-section inline scripts.
   All modules are guard-protected and delegation-based; the rescan
   dispatcher below re-inits section-scoped state after SPA page swaps. */

/* ===== sort-pill ===== */
  (function () {
    if (window.__ovdSortPillInit) return;
    window.__ovdSortPillInit = true;

    function closeAll(except) {
      document.querySelectorAll('.ovd-sortpill.is-open').forEach(function (p) {
        if (p === except) return;
        p.classList.remove('is-open');
        var btn = p.querySelector('[data-sortpill-toggle]');
        if (btn) btn.setAttribute('aria-expanded', 'false');
        var menu = p.querySelector('[data-sortpill-menu]');
        if (menu) menu.setAttribute('aria-hidden', 'true');
      });
    }

    function setActive(value) {
      document.querySelectorAll('.ovd-sortpill__option').forEach(function (o) {
        var on = o.getAttribute('data-value') === value;
        o.classList.toggle('is-active', on);
        o.setAttribute('aria-checked', on ? 'true' : 'false');
      });
    }

    // Price/title/newest sorts reorder the cards already in the DOM — zero
    // network, instant. Featured & Best-selling need Shopify's ordering, so
    // they fall through to the Section Rendering API fetch below.
    var CLIENT_SORTS = {
      'price-ascending':  function (a, b) { return a.price - b.price; },
      'price-descending': function (a, b) { return b.price - a.price; },
      'title-ascending':  function (a, b) { return a.title < b.title ? -1 : a.title > b.title ? 1 : 0; },
      'created-descending': function (a, b) { return b.created - a.created; }
    };

    function sortClientSide(value) {
      var grid = document.querySelector('.collection-products-grid');
      if (!grid || !CLIENT_SORTS[value]) return false;
      var cards = Array.from(grid.children).filter(function (el) {
        return el.hasAttribute && el.hasAttribute('data-sort-price');
      });
      // If cards lack sort data (stale cache), let the fetch path handle it
      if (!cards.length || cards.length !== grid.children.length) return false;
      var keyed = cards.map(function (el) {
        return {
          el: el,
          price: parseFloat(el.getAttribute('data-sort-price')) || 0,
          title: el.getAttribute('data-sort-title') || '',
          created: parseInt(el.getAttribute('data-sort-created'), 10) || 0
        };
      });
      keyed.sort(CLIENT_SORTS[value]);
      var frag = document.createDocumentFragment();
      keyed.forEach(function (k) { frag.appendChild(k.el); });
      grid.appendChild(frag);
      return true;
    }

    // Swap the products in place via Shopify's Section Rendering API — no reload,
    // no white flash. Falls back to a full navigation if anything goes wrong.
    function applySort(value) {
      // Instant path first: reorder in place, sync URL, done.
      if (sortClientSide(value)) {
        var u = new URL(window.location.href);
        u.searchParams.set('sort_by', value);
        u.searchParams.delete('page');
        window.history.replaceState({}, '', u.toString());
        setActive(value);
        return;
      }
      var grid = document.querySelector('.collection-products-grid');
      var section = document.querySelector('.collection-page');
      var sectionId = section && section.getAttribute('data-section-id');

      // User-facing URL: new sort, reset to page 1, keep existing filters
      var pageUrl = new URL(window.location.href);
      pageUrl.searchParams.set('sort_by', value);
      pageUrl.searchParams.delete('page');

      if (!grid || !sectionId) {
        window.location.href = pageUrl.toString();
        return;
      }

      // Section Rendering API URL = same path + same params + &section_id=
      var fetchUrl = new URL(window.location.origin + window.location.pathname);
      pageUrl.searchParams.forEach(function (v, k) { fetchUrl.searchParams.set(k, v); });
      fetchUrl.searchParams.set('section_id', sectionId);

      grid.style.transition = 'opacity 0.18s ease';
      grid.style.opacity = '0.4';
      grid.style.pointerEvents = 'none';

      fetch(fetchUrl.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { if (!r.ok) throw new Error('bad response'); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.querySelector('.collection-products-grid');
          if (!newGrid) throw new Error('no grid in response');
          // Swap only the cards inside the existing grid — preserves the grid
          // element, its column choice, and the grid-toggle state.
          grid.innerHTML = newGrid.innerHTML;
          var newPag = doc.querySelector('.collection-pagination');
          var curPag = document.querySelector('.collection-pagination');
          if (curPag) curPag.innerHTML = newPag ? newPag.innerHTML : '';
          // Keep the URL correct (refresh/share) without polluting history.
          window.history.replaceState({}, '', pageUrl.toString());
          setActive(value);
          grid.style.opacity = '';
          grid.style.pointerEvents = '';
        })
        .catch(function () {
          window.location.href = pageUrl.toString();
        });
    }

    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-sortpill-toggle]');
      if (toggle) {
        e.preventDefault();
        e.stopPropagation();
        var pill = toggle.closest('[data-sortpill]');
        var willOpen = !pill.classList.contains('is-open');
        closeAll(pill);
        pill.classList.toggle('is-open', willOpen);
        toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        var menu = pill.querySelector('[data-sortpill-menu]');
        if (menu) menu.setAttribute('aria-hidden', willOpen ? 'false' : 'true');
        return;
      }

      var opt = e.target.closest('[data-sortpill-option]');
      if (opt) {
        e.preventDefault();
        closeAll(null);
        applySort(opt.getAttribute('data-value'));
        return;
      }

      // Click anywhere outside an open pill closes it
      if (!e.target.closest('[data-sortpill]')) closeAll(null);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll(null);
    });
  })();

/* ===== back-to-top ===== */
(function () {
  if (window.__ovdBacktop) return;
  window.__ovdBacktop = true;
  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      var btn = document.querySelector('[data-backtop]');
      if (btn) btn.hidden = window.scrollY < window.innerHeight * 2;
      ticking = false;
    });
  }, { passive: true });
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-backtop]')) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  });
})();

/* ===== size-chart ===== */
              (function () {
                if (window.__ovdSizeChartToggle) return;
                window.__ovdSizeChartToggle = true;

                function toCm(inches) {
                  var r = Math.round(inches * 2.54 * 10) / 10;
                  return (r % 1 === 0) ? r.toFixed(0) : String(r);
                }

                function convertCell(cell, toCentimeters) {
                  if (toCentimeters) {
                    if (cell.dataset.orig == null) cell.dataset.orig = cell.textContent;
                    cell.textContent = cell.dataset.orig.replace(/\d+(\.\d+)?/g, function (m) {
                      return toCm(parseFloat(m));
                    });
                  } else if (cell.dataset.orig != null) {
                    cell.textContent = cell.dataset.orig;
                  }
                }

                function setUnits(wrap, toCentimeters) {
                  wrap.querySelectorAll('table').forEach(function (table) {
                    var rows = Array.prototype.slice.call(table.querySelectorAll('tr'));
                    rows.forEach(function (row, ri) {
                      var cells = Array.prototype.slice.call(row.children);
                      if (ri === 0) {
                        cells.forEach(function (cell) {
                          if (cell.dataset.origHead == null) cell.dataset.origHead = cell.textContent;
                          cell.textContent = toCentimeters
                            ? cell.dataset.origHead.replace(/\/\s*IN\b/i, '/ CM')
                            : cell.dataset.origHead;
                        });
                        return;
                      }
                      cells.slice(1).forEach(function (cell) { convertCell(cell, toCentimeters); });
                    });
                  });
                  wrap.querySelectorAll('[data-sc-unit]').forEach(function (btn) {
                    btn.classList.toggle('is-active', btn.dataset.scUnit === (toCentimeters ? 'cm' : 'in'));
                  });
                }

                function enhance(wrap) {
                  if (wrap.dataset.scEnhanced) return;
                  if (/centimeter/i.test(wrap.textContent)) { wrap.dataset.scEnhanced = 'skip'; return; }
                  var table = wrap.querySelector('table');
                  if (!table) { wrap.dataset.scEnhanced = 'skip'; return; }
                  wrap.dataset.scEnhanced = '1';

                  var bar = document.createElement('div');
                  bar.className = 'ovd-sc-toggle';
                  bar.innerHTML = '<button type="button" data-sc-unit="in" class="is-active">Inches</button>'
                    + '<button type="button" data-sc-unit="cm">Centimeters</button>';
                  wrap.insertBefore(bar, wrap.firstChild);

                  if (!/may vary/i.test(wrap.textContent)) {
                    var note = document.createElement('p');
                    note.className = 'ovd-sc-note';
                    note.textContent = 'All size chart measurements are taken manually and may vary by 0.5\u20131 inch depending on the fabric, cut, and construction of each piece.';
                    wrap.appendChild(note);
                  }

                  bar.addEventListener('click', function (e) {
                    var btn = e.target.closest('[data-sc-unit]');
                    if (!btn) return;
                    setUnits(wrap, btn.dataset.scUnit === 'cm');
                  });

                  wrap.querySelectorAll('a').forEach(function (a) {
                    if (/^size\s*chart$/i.test(a.textContent.trim())) {
                      a.textContent = 'How to measure your size';
                      a.classList.add('ovd-sc-howto');
                    }
                  });

                  wrap.querySelectorAll('table').forEach(function (tb) {
                    if (tb.parentNode.classList && tb.parentNode.classList.contains('ovd-sc-scroll')) return;
                    var sc = document.createElement('div');
                    sc.className = 'ovd-sc-scroll';
                    tb.parentNode.insertBefore(sc, tb);
                    sc.appendChild(tb);
                  });
                }

                function run(root) {
                  (root || document).querySelectorAll('[data-size-chart-enhance]').forEach(enhance);
                }
                if (document.readyState === 'loading') {
                  document.addEventListener('DOMContentLoaded', function () { run(document); });
                } else {
                  run(document);
                }
                document.addEventListener('shopify:section:load', function (e) { run(e.target); });
                document.addEventListener('ovd:rescan', function () { run(document); });
              })();

/* ===== back-in-stock ===== */
              (function () {
                if (window.__ovdBisInit) return;
                window.__ovdBisInit = true;
                var COMPANY_ID = 'Xkrsir';

                function productForm() { return document.querySelector('form[data-product-form]'); }

                function soldOutNow() {
                  var f = productForm();
                  if (!f) return false;
                  var btn = f.querySelector('.add-to-cart');
                  return !!btn && (btn.disabled || /sold\s*out/i.test(btn.textContent));
                }

                function refresh() {
                  var wrap = document.querySelector('[data-bis-wrap]');
                  if (wrap) wrap.hidden = !soldOutNow();
                }

                document.addEventListener('change', function (e) {
                  if (e.target.closest && e.target.closest('form[data-product-form]')) setTimeout(refresh, 60);
                });
                if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(refresh, 120); });
                else setTimeout(refresh, 120);
                document.addEventListener('ovd:rescan', function () { setTimeout(refresh, 150); });

                document.addEventListener('submit', function (e) {
                  var form = e.target.closest('[data-back-in-stock-form]');
                  if (!form) return;
                  e.preventDefault();
                  var wrap = form.closest('[data-bis-wrap]');
                  var ok = wrap.querySelector('[data-back-in-stock-success]');
                  var err = wrap.querySelector('[data-back-in-stock-error]');
                  var emailEl = form.querySelector('input[name="email"]');
                  var btn = form.querySelector('.back-in-stock-btn');
                  var email = (emailEl.value || '').trim();
                  var idEl = productForm() && productForm().querySelector('[name="id"]');
                  var variantId = idEl && idEl.value;
                  if (!email || !variantId) return;
                  ok.hidden = true; err.hidden = true;
                  btn.disabled = true;
                  fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + COMPANY_ID, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
                    body: JSON.stringify({
                      data: {
                        type: 'back-in-stock-subscription',
                        attributes: {
                          profile: { data: { type: 'profile', attributes: { email: email } } },
                          channels: ['EMAIL']
                        },
                        relationships: {
                          variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId } }
                        }
                      }
                    })
                  }).then(function (r) {
                    if (r.status !== 202) throw new Error('bis ' + r.status);
                    ok.hidden = false;
                    emailEl.value = '';
                  }).catch(function () {
                    err.hidden = false;
                  }).finally(function () {
                    btn.disabled = false;
                  });
                });
              })();

/* ===== ship-nudge ===== */
  (function () {
    if (window.__ovdShipNudge) return;
    window.__ovdShipNudge = true;
    function money(n) {
      var code = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
      try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: code }).format(n).replace(/([.,]00)(?=\s|$)/, ''); }
      catch (e) { return '$' + n.toFixed(2); }
    }
    function update() {
      var el = document.querySelector('[data-ship-nudge]');
      if (!el) return;
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var threshold = parseFloat(el.dataset.threshold) || 333;
          var total = (cart.total_price || 0) / 100;
          if (!cart.item_count) { el.hidden = true; return; }
          if (total >= threshold) {
            el.textContent = 'Your order ships free \uD83C\uDF89';
          } else {
            el.textContent = "You're " + money(threshold - total) + ' away from free shipping';
          }
          el.hidden = false;
        }).catch(function () {});
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update);
    else update();
    document.addEventListener('ovd:rescan', function () { update(); });
    document.addEventListener('cart:add', function () { setTimeout(update, 600); });
    window.addEventListener('cart:updated', function () { setTimeout(update, 300); });
  })();

/* ===== video autoplay kicker (v3 — scroll-based) ===== */
/* OVD editorial video autopilot v3.
   No IntersectionObserver (it is unreliable/neutered in some environments and
   silently never fires). Plain rAF-throttled scroll checks: force play() when
   an editorial video is on screen, pause it when it leaves. Covers full loads,
   SPA swaps, below-fold starts, iOS Low Power. */
(function () {
  if (window.__ovdVideoKick3) return;
  window.__ovdVideoKick3 = true;
  var SEL = '.pstory-media video, .lb-media video, .dropcd-bg video';

  function onScreen(v) {
    var r = v.getBoundingClientRect();
    if (!r.height) return false;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    return r.bottom > vh * 0.05 && r.top < vh * 0.95;
  }
  function tryPlay(v) {
    if (!v.paused) return;
    v.muted = true;
    v.setAttribute('playsinline', '');
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }
  function sweep() {
    var vids = document.querySelectorAll(SEL);
    for (var i = 0; i < vids.length; i++) {
      var v = vids[i];
      if (onScreen(v)) tryPlay(v);
      else if (!v.paused) { try { v.pause(); } catch (e) {} }
    }
  }

  var ticking = false;
  function queueSweep() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { sweep(); ticking = false; });
  }

  window.addEventListener('scroll', queueSweep, { passive: true });
  window.addEventListener('resize', queueSweep, { passive: true });
  document.addEventListener('ovd:rescan', function () { setTimeout(sweep, 150); });
  ['barba:after', 'barba:enter'].forEach(function (ev) {
    window.addEventListener(ev, function () { setTimeout(sweep, 250); });
  });
  document.addEventListener('visibilitychange', function () { if (!document.hidden) sweep(); });
  ['touchstart', 'click'].forEach(function (ev) {
    document.addEventListener(ev, function () { queueSweep(); }, { capture: true, passive: true });
  });
  // Steady heartbeat catches everything else (video injected mid-page, slow
  // buffering finishing, autoplay rejections resolving after first gesture).
  setInterval(sweep, 1200);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sweep);
  else sweep();
})();



/* ===== rescan dispatcher (SPA swaps re-init section-scoped modules) ===== */
(function () {
  if (window.__ovdRescan) return;
  window.__ovdRescan = true;
  function rescan() { document.dispatchEvent(new CustomEvent('ovd:rescan')); }
  ['barba:after', 'barba:enter'].forEach(function (ev) {
    window.addEventListener(ev, function () { setTimeout(rescan, 60); });
  });
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var a = muts[i].addedNodes;
      for (var j = 0; j < a.length; j++) {
        var n = a[j];
        if (n.nodeType === 1 && n.matches && n.matches('[data-barba="container"]')) { setTimeout(rescan, 60); return; }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();